import {
  GetCreditLedgerOverviewResponseSchema,
  type GetCreditLedgerOverviewResponse,
} from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from '../requests-types/custom-use-query-options';

export function useCreditLedgerOverview(
  customerId: string,
  options?: CustomUseQueryOptions<GetCreditLedgerOverviewResponse>,
) {
  return useQuery(
    queryKeys.creditLedgerOverview(customerId),
    async () => {
      const api = getPrivateApi();
      const creditLedgerOverview = await api.getCreditLedgerOverview({
        customerId,
      });

      return GetCreditLedgerOverviewResponseSchema.parse(creditLedgerOverview);
    },
    options,
  );
}
